import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import CveDocument from './CveDocument/CveDocument';

const CveModal = ({ cve, profile, cveFields, onlyKve }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        variant='secondary'
        className='cve-modal-btn'
        onClick={handleShow}
        data-testid='view-cve-button'
      >
        View
      </Button>

      {cve && cve.id ? (
        <Modal className='cve-modal' show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title
              styles={{ fontSize: '1.2rem', marginBottom: '15px' }}
              data-testid='cve-modal-title'
            >
              {cve.id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CveDocument
              cve={cve}
              profile={profile}
              hideId={true}
              cveFields={cveFields}
              onlyKve={onlyKve}
            />
          </Modal.Body>
          {/* <Modal.Footer>
            <Button
              variant='secondary'
              className='cve-modal-btn'
              onClick={handleClose}
            >
              Close
            </Button>
          </Modal.Footer> */}
        </Modal>
      ) : null}
    </>
  );
};

export default CveModal;
